import { FilterMatchMode } from "primevue/api";
import { Options, Vue }    from "vue-class-component";
import { Prop }            from "vue-property-decorator";

import { EntityUserDialog }   from "@/components";
import { AppTable }           from "@sharedComponents";
import { Supplier }           from "@/model/Supplier";
import { User, UserRoleEnum } from "@/model/User";
import { entityUsersService } from "@services/entity-users.service";

@Options( {
    name        : 'SupplierUsers',
    inheritAttrs: false,
    emits       : [ 'save' ],
    components  : {
        AppTable,
        EntityUserDialog
    }
} )
export default class SupplierUsers extends Vue {
    @Prop() readonly supplierId!: string;

    @Prop()
    readonly supplier!: Supplier;

    @Prop()
    readonly isLoading!: boolean;

    showUserDialog: boolean = false;

    editUser = new User();

    filters: any = {
        global : {
            value    : null,
            matchMode: FilterMatchMode.CONTAINS
        },
        name   : {
            value    : null,
            matchMode: FilterMatchMode.CONTAINS
        },
        surname: {
            value    : null,
            matchMode: FilterMatchMode.CONTAINS
        },
        email  : {
            value    : null,
            matchMode: FilterMatchMode.CONTAINS
        },
    }

    get users() {
        return this.supplier?.users || [];
    }

    get roleOptions() {
        return [
            { label: 'Fornitore Admin', value: UserRoleEnum.SUPPLIER_ADMIN },
            { label: 'Fornitore Operatore', value: UserRoleEnum.SUPPLIER_USER },
        ];
    }

    clearFilters() {
        this.filters.global.value  = null;
        this.filters.name.value    = null;
        this.filters.surname.value = null;
        this.filters.email.value   = null;
    }

    onNewUser() {
        this.editUser = new User();
        this.showDialog();
    }

    onEditUser( user: User ) {
        this.editUser = { ...user };
        this.showDialog();
    }

    onRemoveUser( user: User ) {
        this.removeUser( user );
    }

    onSavedUser() {
        this.resetDialog();
        this.hideDialog();

        this.$emit( 'reload' );

        this.$successMessage( 'Utente salvato con successo' );
    }

    private showDialog() {
        this.showUserDialog = true;
    }

    private hideDialog() {
        this.showUserDialog = false;
    }

    private resetDialog() {
        this.editUser = new User();
    }

    private async removeUser( user ) {
        const header = this.$t( 'message.confirm_delete' );

        const message = this.$t(
            'user.delete_message',
            { name: `${ user.name } ${ user.surname }` }
        );

        const response = await this.$confirmMessage( message, header )
        if (response) {
            this.$waitFor( async () => {
                await entityUsersService.remove( user )
                const idx = this.supplier.users.indexOf( user )
                this.supplier.users.splice( idx, 1 );
            } )
        }
    }
}
